export const ACTIONS = {
  UPDATE: 'UPDATE',
  UPDATE_OPTIONS: 'UPDATE_OPTIONS',
};

export function searchInputReducer(prevState, { type, value: state }) {
  switch (type) {
    case ACTIONS.UPDATE:
      const newState = {
        ...prevState,
        ...state,
      };
      const {
        touched,
        multiple,
        values,
        showOptions,
        options,
        displayAliasText,
      } = newState;

      let { userInput, inputValue } = newState;
      let valuePayload = null;

      let filteredOptions = [];
      if (showOptions) {
        const query = userInput.trim();

        if (displayAliasText) {
          filteredOptions = options && options.length && options.filter(
            (option) =>
              option?.text?.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              option?.aliasText?.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        } else {
          filteredOptions = options && options.length && options.filter(
            (option) => option?.text?.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        }

        if (multiple && values.length) {
          filteredOptions = filteredOptions.filter(
            (option) => !values.some((item) => option.text === item.text)
          );
        }
      }

      let hasError = false;
      if (touched && !showOptions) {
        if (multiple && !values.length) {
          hasError = true;
        } else {
          const inputItem = options && options.length && options.find(
            (o) => o.text === userInput || (displayAliasText && o.aliasText === userInput)
          );
          if (!multiple && !inputItem) {
            hasError = true;
          }
        }
      }

      if (!hasError) {
        if (multiple) {
          inputValue = values.map((item) => item.value).join(',');
          valuePayload = values.map((item) => item.payload);
        } else {
          const inputItem = options && options.length && options.find(
            (o) => o.text === userInput || (displayAliasText && o.aliasText === userInput)
          );

          if (inputItem) {
            inputValue = inputItem.value;
            valuePayload = inputItem.payload || null;
            userInput = displayAliasText ? inputItem.aliasText : userInput;
          } else {
            inputValue = '';
            valuePayload = null;
          }
        }
      }

      return {
        ...newState,
        hasError,
        valuePayload,
        inputValue,
        userInput,
        filteredOptions,
      };
    case ACTIONS.UPDATE_OPTIONS:
      return {
        ...prevState,
        activeOption: 0,
        filteredOptions: [],
        values: [],
        options: state.options,
        userInput: '',
        showOptions: false,
        hasError: false,
        touched: false,
        focused: false,
        inputValue: '',
      };
    default:
      return prevState;
  }
}
